var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 32,
      height: 32,
      viewBox: "0 0 32 32",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.3334 23.592H6.66676C5.93209 23.592 5.33343 23.026 5.33343 22.3286V10.01L15.2001 17.0221C15.4374 17.1914 15.7188 17.2748 16.0001 17.2748C16.2814 17.2748 16.5628 17.1914 16.8001 17.0221L26.6668 10.01V22.3286C26.6668 23.026 26.0681 23.592 25.3334 23.592ZM24.4441 8.43069L16.0001 14.432L7.55608 8.43069H24.4441ZM25.3334 5.90381H6.66675C4.46141 5.90381 2.66675 7.6044 2.66675 9.69413V22.3286C2.66675 24.4183 4.46141 26.1189 6.66675 26.1189H25.3334C27.5387 26.1189 29.3334 24.4183 29.3334 22.3286V9.69413C29.3334 7.6044 27.5387 5.90381 25.3334 5.90381Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgEmail, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/email.27cd156e.svg";
export { ForwardRef as ReactComponent };